import React, { useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { Flex, Text } from '@radix-ui/themes';
import { useClinicAdmin } from '../../hooks/useClinicAdmin';

const LoadingScreen: React.FC = () => (
  <Flex
    direction="column"
    justify="center"
    align="center"
    className="min-h-screen"
    style={{
      background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)'
    }}
  >
    <div className="animate-spin rounded-full h-16 w-16 border-4 border-white border-t-transparent mb-4"></div>
    <Text size="5" style={{ color: 'white' }}>
      Verifying clinic access...
    </Text>
  </Flex>
);

export const ClinicAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isClinicAdmin, loading } = useClinicAdmin();
  // PHA-626: the access check re-runs whenever the auth user object or the selected clinic
  // changes, several times right after the page opens. Swapping the page for the loading
  // screen on every re-check unmounted it and threw away whatever an admin was typing (the
  // onboarding-script and consent editors). Show it only until the first check finishes;
  // after that keep the page mounted, and still leave if a re-check says "not an admin".
  const checkedOnce = useRef(false);
  if (!loading) checkedOnce.current = true;

  if (loading && !checkedOnce.current) {
    return <LoadingScreen />;
  }

  if (!isClinicAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ClinicAdminRoute;
